/*jslint white: true, browser: true, devel: true, nomen: true, sloppy: true, indent: 4, maxerr: 50,	 plusplus: true, vars: false */
/*jshint -W030, -W041, -W098 */

/* exported ScannerCanvas */


/**
 * Scanning preview drawing
 *
 */
function ReviewCanvas() {
    this.topView = "topView", this.sideView = "sideView";
    "use strict";

    var self = this,
        drawDOM;

    self.viewConfig = {
        background: "white",

        rulerStroke: "lightgray",
        rulerWidth: 1,
        rulerDotPattern: 3,
        rulerXbottom: 0.1,
        rulerSelectedStroke: "#4FABE0",
        rulerSelectedWidth: 3,

        textColor: "black",
        textFont: "14px UCSLato",
        bottomTextFont: "20px UCSLato",
        showFootText: true,
        letterLength: "l",
        letterWidth: "w",
        letterHeight: "h",

        contourFill: "#CCC",
        contourWidth: 1,
        contourStroke: "#777",
        drawContourGrid: false,
        contourGridSrc: "img/pattern.png",

        circleFill: "black",
        circleYpos: 0.64,
        circleRatioD: 14,
        circleTextColor: "white",
        circleTextFont: "UCSLato",

        showLENGTH: false,
        showWIDTH: false,
        showHEIGHT: false,
        showGIRTH: false
    };

    function drawContour(ctx, contour, f, width) {
        var i, n;

        if (!contour || contour.length < 2) {
            return;
        }
        ctx.beginPath();
        if (width != null) {
            ctx.moveTo((contour[0]) * f, (width - contour[1]) * f);
            for (i = 2, n = contour.length; i < n; i = i + 2) {
                ctx.lineTo(contour[i] * f, (width - contour[i + 1]) * f);
            }
        } else {
            ctx.moveTo(contour[0] * f, contour[1] * f);
            for (i = 2, n = contour.length; i < n; i = i + 2) {
                ctx.lineTo(contour[i] * f, contour[i + 1] * f);
            }
        }
        ctx.closePath();
        ctx.fill();
        if(self.viewConfig.drawContourGrid) {
            ctx.fillStyle = ctx.createPattern(self.viewConfig.contourGridElement, 'repeat');
            ctx.fill();
        }
        ctx.stroke();
    }

    function findMinMax(pol, res) {

        var ymin = 999,
            ymax = 0,
            xmin = 999,
            xmax = 0,
            k,
            x, y, xxmax = 0,
            xymax = 0,
            xxmin = 999,
            xymin = 999,
            ft = true;

        k = pol.length / 2;

        while (k--) {
            y = pol[k * 2 + 1];
            x = pol[k * 2];
            if (y > ymax || ft) {
                ymax = y;
                xmax = x;
            }
            if (y < ymin || ft) {
                ymin = y;
                xmin = x;
            }

            if (x > xxmax || ft) {
                xxmax = x;
                xymax = y;
            }
            if (x < xxmin || ft) {
                xxmin = x;
                xymin = y;
            }
            ft = false;
        }
        /* if (xmin > xmax) {
             k = xmax;
             xmax = xmin;
             xmin = k;
         }

         if (xymin > xymax) {
             k = xymax;
             xymax = xymin;
             xymin = k;
         }*/
        res = res || {};

        res.ymin = ymin;
        res.xmin = xmin;
        res.ymax = ymax;
        res.xmax = xmax;

        res.xymin = xymin;
        res.xxmin = xxmin;
        res.xxmax = xxmax;
        res.xymax = xymax;

        res.width = (res.ymax - res.ymin);
        res.height = (res.xxmax - res.xxmin);

        return res;
    }

    function rotateSideFootData (leftFoot, rightFoot) {
        var i, tmp;
        for(i = 0; i< leftFoot.contour.data.length; i+=2) {
            tmp = leftFoot.contour.data[i];
            leftFoot.contour.data[i] = leftFoot.contour.data[i+1];
            leftFoot.contour.data[i+1] = tmp;
        }
        leftFoot.rotated = true;
        var rmm = findMinMax(rightFoot.contour.data, {});
        for(i = 0; i< rightFoot.contour.data.length; i+=2) {
            tmp = rightFoot.contour.data[i];
            rightFoot.contour.data[i] = rightFoot.contour.data[i+1];
            rightFoot.contour.data[i+1] = rmm.xxmax - tmp;
        }
        rightFoot.rotated = true;
    }

    function find55Height(foot, isLeft) {
        var closest = {
            index: -1,
            diff: 9999
        };
        for(var i = 0; i < foot.contour.data.length; i+=2) {
            var dimen = foot.contour.data[i+1], difference = isLeft ? foot.mm.ymax * 0.55 - dimen : foot.mm.ymax * 0.45 - dimen;
            if(Math.abs(difference) < Math.abs(closest.diff) && foot.contour.data[i] > foot.mm.xxmax / 4) {
                closest.diff = difference;
                closest.index = i;
            }
        }
        foot.sideMeasurementDataIndex = closest.index;
        // console.log(closest, foot.contour.data[closest.index], foot.contour.data[closest.index+1]);
    }

    function drawVline(ctx, x, y, y2, solid) {

        if(!solid) {
            var t = y,
                b = false,
                space = 3;
            ctx.beginPath();
            ctx.moveTo(x, y);

            while (t <= y2) {
                if (b) {
                    ctx.lineTo(x, t);
                } else {
                    ctx.moveTo(x, t);
                }
                t += space;
                b = !b;
            }
            if (b && t > y2)
                ctx.lineTo(x, y2);
        } else {
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x, y2);
        }
        ctx.stroke();
    }

    function drawHline(ctx, x, y, x2, solid) {

        if(!solid) {
            var t = x,
                b = false,
                space = 3;
            ctx.beginPath();
            ctx.moveTo(x, y);

            while (t <= x2) {
                if (b) {
                    ctx.lineTo(t, y);
                } else {
                    ctx.moveTo(t, y);
                }
                t += space;
                b = !b;
            }
            if (b && t > x2)
                ctx.lineTo(x2, y);
        } else {
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x2, y);
        }
        ctx.stroke();
    }

    function drawFoot(ctx, config, foot, isLeft, footHp, scaleFactor, topTextMargin, bottomTextMargin) {

        var mm = foot.mm, text;
            // centerY, centerX, radius, tmp;

        //draw foot contor
        ctx.save();
        ctx.translate(0, footHp);
        ctx.scale(-1, -1);
        ctx.rotate(Math.PI / 2);
        ctx.translate(-mm.xxmin * scaleFactor, 1);
        ctx.lineJoin = "round";
        ctx.lineWidth = config.contourWidth;
        ctx.strokeStyle = config.contourStroke;
        ctx.fillStyle = config.contourFill;

        drawContour(ctx, foot.contour.data, scaleFactor, mm.ymax);
        ctx.restore();

        /* draw circle */
        ctx.translate(0, footHp);

        /*if (foot.shoeNumber) {

            centerY = -(mm.height) * scaleFactor * config.circleYpos;
            centerX = (mm.width) * scaleFactor / 2;
            radius = footHp / config.circleRatioD;

            ctx.beginPath();
            ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
            ctx.fillStyle = config.circleFill;
            ctx.fill();
            ctx.lineWidth = 0;
            ctx.strokeStyle = 'none';
            ctx.stroke();

            // shoe number in the circle
            tmp = Math.round(2 * radius / 3);
            ctx.fillStyle = config.circleTextColor;
            ctx.font = "" + tmp + "px " + config.circleTextFont;

            ctx.fillText(foot.shoeNumber, centerX - (ctx.measureText(foot.shoeNumber).width / 2), centerY + tmp / 2.5);

        }*/

        // Draw lines
        ctx.lineJoin = "bevel";
        ctx.lineWidth = config.rulerWidth;
        ctx.strokeStyle = config.rulerStroke;
        ctx.font = config.scaledTextFont;

        //Draw lines -- left side
        if (isLeft) {
            drawVline(ctx, mm.width * scaleFactor + 3, -mm.height * scaleFactor - (topTextMargin), topTextMargin); //left leg right side
            drawHline(ctx, -topTextMargin, -mm.height * scaleFactor - 2, mm.width * scaleFactor + (topTextMargin)); //left leg top side
            if(config.view === self.topView) {
                drawVline(ctx, -1, -mm.height * scaleFactor - topTextMargin, (-mm.xmax + mm.xxmin) * scaleFactor + topTextMargin); //left leg left side
                drawHline(ctx, mm.width * scaleFactor * (config.rulerXbottom), 2, mm.width * scaleFactor + (topTextMargin)); //left leg bottom side
            } else {
                drawVline(ctx, -1, -mm.height * scaleFactor - topTextMargin, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor); //left leg left side
                drawHline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, 2, mm.width * scaleFactor + (topTextMargin)); //left leg bottom side
                // drawVline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, 0); //left leg height
                // drawHline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, mm.width * scaleFactor + 2); //left leg height
            }
        //Draw lines -- right side
        } else {
            drawVline(ctx, -1, -mm.height * scaleFactor - topTextMargin, topTextMargin); //right leg left side
            drawHline(ctx, -topTextMargin, -mm.height * scaleFactor - 2, mm.width * scaleFactor + topTextMargin); //right leg top side
            if(config.view === self.topView) {
                drawVline(ctx, mm.width * scaleFactor + 3, -mm.height * scaleFactor - topTextMargin, (-mm.xmin + mm.xxmin) * scaleFactor + topTextMargin); //right leg right side
                drawHline(ctx, -topTextMargin, 2, mm.width * scaleFactor * (1 - config.rulerXbottom)); //right leg bottom side
            } else {
                drawVline(ctx, mm.width * scaleFactor + 3, -mm.height * scaleFactor - topTextMargin, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor);  //right leg right side
                drawHline(ctx, -topTextMargin, 2, (mm.width -foot.contour.data[foot.sideMeasurementDataIndex+1]) * scaleFactor); //right leg bottom side
                // drawVline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, 0);  //right leg height
                // drawHline(ctx, -1, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor + 2);  //right leg height
            }
        }

        //Draw selected lines
        ctx.lineWidth = config.rulerSelectedWidth;
        ctx.strokeStyle = config.rulerSelectedStroke;
        if(config.view === self.topView) {
            if(config.showWIDTH) {
                drawHline(ctx, -1, -mm.height * scaleFactor - 2, mm.width * scaleFactor + 2.5, true); // widths
            }
            if(config.showLENGTH) { // lengths top view
                if(isLeft) {
                    drawVline(ctx, mm.width * scaleFactor + 3, -mm.height * scaleFactor -1, 2, true);
                }
                else {
                    drawVline(ctx, -1, -mm.height * scaleFactor - 1, 2, true);
                }
            }
        } else {
            // if(config.showLENGTH) { // lengths side view
            //     if(isLeft) {
            //         drawHline(ctx, -1, -mm.height * scaleFactor - 2, mm.width * scaleFactor + 2.5, true);
            //     }
            //     else {
            //         drawHline(ctx, -1, -mm.height * scaleFactor - 2, mm.width * scaleFactor + 2.5, true);
            //     }
            // }
            if(config.showHEIGHT) {
                drawVline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, 0, true); //left leg height
                if(isLeft) {
                    drawHline(ctx, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, mm.width * scaleFactor + 2, true);
                } else {
                    drawHline(ctx, -1, -foot.contour.data[foot.sideMeasurementDataIndex] * scaleFactor, (mm.width - foot.contour.data[foot.sideMeasurementDataIndex + 1]) * scaleFactor + 2, true);
                }
            }
        }

        text = foot.bottomText;
        ctx.font = config.scaledBottomTextFont;
        ctx.fillStyle = config.textColor;
        if(config.showFootText)
            ctx.fillText(text, mm.width / 2 * scaleFactor - ctx.measureText(text).width / 2, bottomTextMargin);


        ctx.font = config.scaledTextFont;
        ctx.fillStyle = config.textColor;

        //top text
        if(config.view === self.sideView)
            text = config.letterLength + "=" + Math.round(foot.footLength / 10.0);
        else
            text = config.letterWidth + "=" + Math.round(foot.footWidth / 10.0);
        if(config.showFootText)
            ctx.fillText(text, mm.width / 2 * scaleFactor - ctx.measureText(text).width / 2, -footHp - 1.5 * topTextMargin);

        // side text
        if(config.view === self.sideView)
            text = config.letterHeight + "=" + Math.round(foot.footHeight / 10.0);
        else
            text = config.letterLength + "=" + Math.round(foot.footLength / 10.0);
        if (isLeft) {
            ctx.fillText(text, mm.width * scaleFactor + topTextMargin / 2, -footHp / 2 + 0.5 * topTextMargin);
        } else {
            ctx.fillText(text, -ctx.measureText(text).width - topTextMargin / 2, -footHp / 2 + 0.5 * topTextMargin);
        }
    }

    this.draw = function (resized) {
        var leftFoot = self.leftFoot,
            rightFoot = self.rightFoot,
            canvasHeight0,
            canvasWidth0,
            ctx, elem,
            config = self.viewConfig,
            ratio = 1;

        resized = resized || !drawDOM.canvasHeight;

        if (resized) {
            resizeCanvas(ratio);
            if (!drawDOM.canvasHeight) return;
        }

        elem = drawDOM.myCanvas;
        if (!elem || !elem.getContext) {
            return;
        }
        ctx = elem.getContext('2d');
        if (!ctx) {
            return;
        }

        var dPR = window.devicePixelRatio || 1,
            bSR = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio ||
                ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio ||
                ctx.backingStorePixelRatio || 1;
        ratio = dPR / bSR >= 1 ? dPR / bSR : 1;
        resizeCanvas(ratio);

        if (!leftFoot || !rightFoot) {
            console.log("missing foot data");
            return;
        }

        /* --------------------------------------------------------- */
        canvasWidth0 = ctx.canvas.width;
        canvasHeight0 = ctx.canvas.height;
        ctx.clearRect(0, 0, canvasWidth0, canvasHeight0);
        ctx.fillStyle = config.background;
        ctx.fillRect(0, 0, canvasWidth0, canvasHeight0);

        // **** calculate space  ****
        var topSpace,
            sideSpace,
            bottomSpace,
            middleSpace,
            topTextMargin,
            bottomTextMargin,
            xMargin,
            yMargin,
            footHp,
            footWp,
            footH,
            footW,
            scaleFactor = 1,
            tmp,
            lmm, rmm;

        ctx.save();

        // top text margin
        ctx.font = config.scaledTextFont;
        topTextMargin = ctx.measureText("W").width;
        if(config.view === self.topView) {
            middleSpace = ctx.measureText((config.letterLength + "=" + Math.max(leftFoot.footWidth, rightFoot.footWidth)+"w")).width;
        } else {
            middleSpace = ctx.measureText((config.letterHeight + "=" + Math.max(leftFoot.footHeight, rightFoot.footHeight)+"l")).width;
        }
        topSpace = config.showFootText ? topTextMargin * 3.5 : topTextMargin;
        sideSpace = topTextMargin * 2;

        ctx.font = config.scaledBottomTextFont;
        tmp = ctx.measureText("W").width;

        bottomTextMargin = tmp + (topTextMargin * 8 / 5);
        bottomSpace = config.showFootText ? bottomTextMargin + tmp * 1.5 : bottomTextMargin;

        if(self.viewConfig.view === self.sideView && leftFoot.rotated !== true && rightFoot.rotated !== true) {
            rotateSideFootData(leftFoot, rightFoot);
        }

        // calcualte mm
        if (!leftFoot.mm) {
            leftFoot.mm = findMinMax(leftFoot.contour.data, {});
        }
        lmm = leftFoot.mm;

        if (!rightFoot.mm) {
            rightFoot.mm = findMinMax(rightFoot.contour.data, {});
        }
        rmm = rightFoot.mm;

        if(config.view === self.sideView) {
            find55Height(leftFoot, true);
            find55Height(rightFoot, false);
        }

        // define largest width and height
        footH = lmm.height;
        if (rmm.height > footH) footH = rmm.height;

        footW = lmm.width;
        if (rmm.width > footW) footW = rmm.width;

        ctx.restore();

        // **************************

        var tfh = canvasHeight0 - topSpace - bottomSpace;
        var tfw = canvasWidth0 / 2 - (sideSpace + middleSpace);

        if (tfh <= 0 || tfw <= 0) return;

        //check width
        tmp = tfh * footW / footH;

        if (tmp <= tfw) {
            footHp = tfh;
            footWp = tmp;
            xMargin = tfw - tmp;
            yMargin = 0;
        } else {
            tmp = tfw * footH / footW;
            footWp = tfw;
            footHp = tmp;
            xMargin = 0;
            yMargin = (tfh - tmp) / 2;
        }

        scaleFactor = (footHp) / (footH);

        /* ---------------------------------------------------- */
        /* LEFT SIDE */
        ctx.save();

            //Reset transformation
            ctx.setTransform(1, 0, 0, 1, 0, 0);

            //Move coordinate system
            ctx.translate(canvasWidth0 / 2 - middleSpace - lmm.width * scaleFactor, yMargin + topSpace);

            drawFoot(ctx, config, leftFoot, true, footHp, scaleFactor, topTextMargin, bottomTextMargin);

            ctx.setTransform(1, 0, 0, 1, 0, 0);

            //Move coordinate system
            ctx.translate(canvasWidth0 / 2 + middleSpace, yMargin + topSpace);

            drawFoot(ctx, config, rightFoot, false, footHp, scaleFactor, topTextMargin, bottomTextMargin);
        ctx.restore();

        return;

    };

    this.updateConfig = function (key, value) {
        self.viewConfig[key] = value;
        if( key !== "showGirth")
        self.draw(true);
    };

    function resizeCanvas(ratio) {
        var wrapper = drawDOM.canvasWrapper;
        drawDOM.myCanvas.style.width = wrapper.clientWidth;
        drawDOM.myCanvas.style.height = wrapper.clientHeight;
        drawDOM.myCanvas.width = wrapper.clientWidth * ratio;
        drawDOM.canvasHeight = drawDOM.myCanvas.height = wrapper.clientHeight * ratio;
        var fontParts = self.viewConfig.textFont.split(" "), fontSize = fontParts[0], fontFamily = fontParts[1];
        var bottomFontParts = self.viewConfig.bottomTextFont.split(" "), bottomFontSize = bottomFontParts[0], bottomFontFamily = bottomFontParts[1];
        try {
            var downscaledRatio = ratio > 2 ? ratio/2 : ratio;
            self.viewConfig.scaledTextFont = parseInt(fontSize) * downscaledRatio + "px " + fontFamily;
            self.viewConfig.scaledBottomTextFont = parseInt(bottomFontSize) * downscaledRatio + "px " + bottomFontFamily;
        } catch (err) {
            console.log("Error: " + err);
            self.viewConfig.scaledTextFont = self.viewConfig.textFont;
            self.viewConfig.scaledBottomTextFont = self.viewConfig.bottomTextFont;
        }
    }

    this.setResized = function () {
        drawDOM.canvasHeight = 0;
    };

    /**
     * Initialize
     * @param {HTMLElement} canvas        [[Description]]
     * @param {HTMLElement} canvasWrapper [[Description]]
     * @param {Object} viewConfig    [[Description]]
     */
    this.init = function (canvas, canvasWrapper, viewConfig) {
    	for(var param in viewConfig) {
    	    self.viewConfig[param] = viewConfig[param];
        }

        try {
            var pattern = new Image();
            pattern.src = self.viewConfig.contourGridSrc;
            self.viewConfig.contourGridElement = pattern;
        } catch (err) {
            console.log("Error " + err);
        }

        try {
            drawDOM = {
                myCanvas: canvas,
                canvasWrapper: canvasWrapper,
                canvasHeight: 0
            };

            // utl.apply(config.viewConfig, self.viewConfig, true);
            // self.viewConfig = config.viewConfig;

        } catch (e) {
            console.log("Error " + e);
        }
    };


    this.clearData = function () {
        self.leftFoot = {
            contour: {
                data: []
            }
        };
        self.rightFoot = {
            contour: {
                data: []
            }
        };
    };

    this.clear = function (resize) {

        try {
            self.clearData();

            //self.draw(resize);
            var elem, ctx;
            elem = drawDOM.myCanvas;
            if (elem && elem.getContext) {
                ctx = elem.getContext('2d');
                if (ctx) {
                    if (resize)
                        resizeCanvas();
                    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                }
            }

        } catch (err) {
            alert("clear error" + err.stack);
        }
    };

    this.dispose = function () {
        drawDOM = null;
    };

    //init
    this.clearData();
}
